import { render, staticRenderFns } from "./StatistList.vue?vue&type=template&id=af47aa5e&scoped=true&"
import script from "./StatistList.vue?vue&type=script&lang=js&"
export * from "./StatistList.vue?vue&type=script&lang=js&"
import style0 from "./StatistList.vue?vue&type=style&index=0&id=af47aa5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af47aa5e",
  null
  
)

export default component.exports